import { getQuery } from '@/utils';

export const isShopify = () => {
  const { platform } = getQuery();

  return platform === 'shopify';
};
